import { useState } from "react";
import { toast } from "sonner";
import { DashboardLayout } from "@/components/DashboardLayout";
import { ownerNav } from "@/config/nav";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ChangePasswordDialog } from "@/components/ChangePasswordDialog";
import { LockKey } from "@phosphor-icons/react";

export default function OwnerProfile() {
  const { user, updateUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [cpOpen, setCpOpen] = useState(false);

  const save = async () => {
    const r = await api.put("/auth/profile", { name, phone });
    updateUser(r.data);
    toast.success("Profile updated");
  };

  return (
    <DashboardLayout nav={ownerNav} title="Owner">
      <h1 className="font-heading text-2xl font-semibold text-stone-900 md:text-3xl">Profile</h1>
      <div className="mt-6 max-w-lg rounded-2xl border border-stone-200 bg-white p-6">
        <div className="flex items-center gap-4">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary text-2xl font-bold text-white">{user?.name?.[0]?.toUpperCase()}</div>
          <div><p className="font-heading text-lg font-semibold">{user?.name}</p><p className="text-sm text-stone-500">{user?.email}</p></div>
        </div>
        <div className="mt-6 space-y-4">
          <div><Label>Name</Label><Input data-testid="op-name" value={name} onChange={(e) => setName(e.target.value)} className="mt-1 rounded-xl" /></div>
          <div><Label>Phone</Label><Input data-testid="op-phone" value={phone} onChange={(e) => setPhone(e.target.value)} className="mt-1 rounded-xl" /></div>
          <div><Label>Email</Label><Input value={user?.email} disabled className="mt-1 rounded-xl bg-stone-50" /></div>
          <Button data-testid="op-save" onClick={save} className="rounded-xl bg-primary hover:bg-green-900">Save Changes</Button>
        </div>
      </div>

      <div className="mt-4 max-w-lg rounded-2xl border border-stone-200 bg-white p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2"><LockKey size={20} weight="duotone" className="text-primary" /><p className="font-heading font-semibold text-stone-900">Password & Security</p></div>
          <Button data-testid="op-change-password" variant="outline" className="rounded-xl" onClick={() => setCpOpen(true)}>Change Password</Button>
        </div>
        <p className="mt-2 text-sm text-stone-500">Keep your account secure with a strong password you don't use elsewhere.</p>
      </div>
      <ChangePasswordDialog open={cpOpen} onOpenChange={setCpOpen} />
    </DashboardLayout>
  );
}
